import { aParams } from './url-filtros';
import { ESQUEMAS_POR_RUTA } from './filtros-esquemas';
import {
  MAPA_SISTEMA,
  CARPETAS_SIN_PANTALLA,
  type PantallaDelSistema,
} from '@conversia/shared-types';

/**
 * A8 · EL MAPA DEL SISTEMA — los helpers del panel.
 *
 * EL DATO se mudó a `@conversia/shared-types` porque el API también lo necesita:
 * el copiloto elige a qué pantalla mandarte leyendo de ahí. Con una copia de
 * cada lado, el copiloto terminaría ofreciendo pantallas que el panel ya no
 * tiene, y nadie se enteraría hasta que alguien tocara un botón muerto.
 *
 * Los helpers se quedan acá porque dependen de los esquemas de filtro, que son
 * del panel. El dato se re-exporta para no romper a quien ya lo importaba desde
 * este archivo.
 */
export { MAPA_SISTEMA, CARPETAS_SIN_PANTALLA };
export type { PantallaDelSistema };

/** La pantalla de una ruta, resolviendo subrutas. `null` si no está. */
export function pantallaDeRuta(ruta: string): PantallaDelSistema | null {
  let mejor: PantallaDelSistema | null = null;
  for (const p of MAPA_SISTEMA) {
    const coincide = p.ruta === '/' ? ruta === '/' : ruta === p.ruta || ruta.startsWith(`${p.ruta}/`);
    if (coincide && (!mejor || p.ruta.length > mejor.ruta.length)) mejor = p;
  }
  return mejor;
}

/**
 * El enlace a una pantalla con filtros. `null` si la pantalla no existe.
 *
 * **Es la función que usa el copiloto para sus botones**, y por eso es
 * deliberadamente desconfiada: descarta los filtros que la pantalla no acepta y
 * devuelve `null` para una ruta desconocida. El modelo no puede inventar un
 * destino ni un parámetro — solo elegir entre lo que existe.
 *
 * Un botón que lleva a una pantalla inexistente es peor que no tener botón.
 */
export function enlaceAPantalla(ruta: string, filtros: Record<string, unknown>): string | null {
  const pantalla = MAPA_SISTEMA.find((p) => p.ruta === ruta);
  if (!pantalla) return null;

  const esquema = ESQUEMAS_POR_RUTA[ruta];
  if (!esquema) return ruta;

  const permitidos: Record<string, string | boolean | number | undefined> = {};
  for (const clave of pantalla.filtros) {
    const v = filtros[clave];
    if (v !== undefined && v !== null) {
      permitidos[clave] = v as string | boolean | number;
    }
  }

  const qs = aParams(permitidos, esquema).toString();
  return qs ? `${ruta}?${qs}` : ruta;
}
